// sanitize

export const blockListAttributes = ['data-popover-id'];
export const cosElementId = 'hs_cos_wrapper';
export const blockListEditorAttributes = ['data-hs-row-id', 'data-hs-cell-id', 'data-hs-tree-id'];
export const hsSanitizeAllow = 'data-mce-sanitize-allow';
export const CORE_SETTINGS = 'hscore_settings';